/**
 * Легенда під графіком — частина єдиного стандарту (див. chartTheme.ts).
 *
 * Recharts-івський <Legend> не піддається токенізації: він малює власні
 * підписи системним шрифтом і кольором серії, тож в еталонних «Цінах» і
 * «Прогнозі» його не використовують. Тут та сама розмітка, що там: рядок
 * по центру, 12px, колір --text-muted, зразок серії — коротка риска.
 */
export interface ChartLegendItem {
  label: string;
  color: string;
  /** Пунктир — для довідкових/планових ліній. */
  dashed?: boolean;
  /** Для стовпців: зразок малюється прямокутником, а не рискою. */
  bar?: boolean;
}

export default function ChartLegend({ items }: { items: ChartLegendItem[] }) {
  return (
    <div className="flex items-center justify-center gap-x-5 gap-y-1.5 flex-wrap pt-3">
      {items.map((it) => (
        <span key={it.label} className="inline-flex items-center gap-1.5"
          style={{ fontSize: 12, color: 'var(--text-muted)' }}>
          {it.bar ? (
            <span style={{
              width: 11, height: 11, borderRadius: 3, display: 'inline-block',
              background: it.color, opacity: 0.42, border: `1.4px solid ${it.color}`,
            }} />
          ) : (
            <span style={{
              width: 16, height: 0, display: 'inline-block',
              borderTop: `3px ${it.dashed ? 'dashed' : 'solid'} ${it.color}`,
            }} />
          )}
          {it.label}
        </span>
      ))}
    </div>
  );
}
